import * as s from "./MissingStyled";

import { useAppSelector } from "redux/hooks";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { UnknownRecorderList } from "api/interfaces/recorderInterface.interface";
import AccountId from "components/atoms/text/labels/AccountId";

import { WithTooltip } from "components/blocks/WithTooltip";
import useAccountAccess from "hook/useAccountAccess";

type Props = {
  item: UnknownRecorderList;
  onChangeEach: (e: any, id: string) => void;
  checkList: string[];
};

const MissingListItem = ({
  item,
  onChangeEach,
  checkList,
}: Props): JSX.Element => {
  const selectedAccount = useAppSelector((state) => state.accountSettings);
  const { AccountAccessButton, AccountAccessModal } = useAccountAccess({
    buttonType: (
      <WithTooltip
        tooltip={
          <>
            {item.accountName}
            <br />
            {item.accountNumber}
          </>
        }
      >
        <AccountId accountId={`${item.accountName}`} level={LEVEL_TYPE.EU} />
      </WithTooltip>
    ),

    useTemporary: false,
    isShowOnlyUser: true,
  });

  return (
    <s.ListItem accountLevel={selectedAccount.accountLevel}>
      <label>
        <span className="recorder-name-wrapper">
          {selectedAccount.accountLevel === LEVEL_TYPE.EU && (
            <input
              className="input_checkbox"
              type="checkbox"
              name={item.recorderId}
              onChange={(e) => onChangeEach(e, item.recorderId)}
              checked={checkList.includes(item.recorderId)}
              data-testid="dashboard-map-missing-list-input-change-each"
            />
          )}

          <div className="recorder-name">
            <span className="title">
              {item.type === "Spectrum"
                ? item.mergedSystemName
                : item.recorderName}
            </span>
            {item.type === "Spectrum" && (
              <span className="mergedSystemName">{item.recorderName}</span>
            )}
          </div>
        </span>
        {selectedAccount.accountLevel === LEVEL_TYPE.CP && (
          <AccountAccessButton accountId={item.accountId} />
        )}
      </label>
      {selectedAccount.accountLevel === LEVEL_TYPE.CP && AccountAccessModal}
    </s.ListItem>
  );
};

export default MissingListItem;
